export default "__VITE_ASSET__5a6420f4__"